import { render, staticRenderFns } from "./introCom.vue?vue&type=template&id=462b68e7&scoped=true&"
import script from "./introCom.vue?vue&type=script&lang=js&"
export * from "./introCom.vue?vue&type=script&lang=js&"
import style0 from "./introCom.vue?vue&type=style&index=0&id=462b68e7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462b68e7",
  null
  
)

export default component.exports